import React from 'react'
import './LocationIndicator.css'
import classNames from 'classnames'

const LocationIndicator = ({ slides = [], currentSlide = 0, handleLocationIndicatorClick, ...props }) => {
  let classes = classNames({
    'LocationIndicator': true
  })

  return (
    <div className={classes} {...props}>
      {slides.map((s) => {
        let activeClass = classNames({
          'LocationIndicator-Dot': true,
          'm-Active': s.index === currentSlide
        })

        return (
          <span
            key={s.index}
            className={activeClass}
            onClick={e => handleLocationIndicatorClick(e, s.index)} />
        )
      })}
    </div>
  )
}

export default LocationIndicator



// WEBPACK FOOTER //
// ./src/Components/LocationIndicator/LocationIndicator.js